export const parseNewlines = str => (/<br>|<br(\s?)\/>/.test(str) ? str : str.replace(/(?:\r\n|\r|\n)/g, '<br />\n'));
